import { render, staticRenderFns } from "./AssignGrade.vue?vue&type=template&id=96e9205c&scoped=true&"
import script from "./AssignGrade.vue?vue&type=script&lang=js&"
export * from "./AssignGrade.vue?vue&type=script&lang=js&"
import style0 from "./AssignGrade.vue?vue&type=style&index=0&id=96e9205c&lang=scss&scoped=true&"
import style1 from "./AssignGrade.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e9205c",
  null
  
)

export default component.exports